import { ListItem } from "@mui/material";

import ProviderSettlementStatusSelect from "../../../../cm/Dashboard/FullPages/Settlement/MedicalBreakdown/ProviderSettlementStatusSelect";
import HNSColors from "../../../../ui library/HNSColors";

import EditableCurrencyCell from "./EditableCurrencyCell";

const COMMON_CLASSES =
  "min-h-[56px] border-b px-3 py-2 text-sm transition-colors group-hover:bg-[var(--medical-cell-hover)]";

export default function MedicalBreakdownRow({
  detail,
  statusOptions = [],
  onSaveSuccess,
  canEdit = false,
}) {
  return (
    <ListItem className="p-0">
      <div
        className="group flex min-w-[925px] w-full border-b transition-colors last:border-b-0 hover:bg-[var(--medical-row-hover)]"
        style={{
          borderColor: HNSColors.neutrals[700],
          backgroundColor: "var(--medical-row-bg)",
          color: HNSColors.neutrals[300],
          "--medical-row-bg": HNSColors.neutrals[900],
          "--medical-row-hover": HNSColors.tertiary[950],
          "--medical-cell-hover": HNSColors.tertiary[800],
        }}
      >
        <div
          className={`${COMMON_CLASSES} sticky left-0 z-10 flex w-[190px] flex-none items-center justify-start border-r bg-[var(--medical-row-bg)] px-4 text-left font-medium transition-colors group-hover:bg-[var(--medical-cell-hover)]`}
          style={{
            borderColor: HNSColors.neutrals[700],
            color: HNSColors.neutrals[100],
          }}
        >
          <span className="block w-full break-words whitespace-normal">
            {detail?.providerName ?? detail?.provider_name}
          </span>
        </div>
        <div
          className={`flex w-[120px] flex-none grow items-center justify-center border-r ${COMMON_CLASSES}`}
          style={{ borderColor: HNSColors.neutrals[700] }}
        >
          <span className="mr-1">$</span>
          <span>{detail?.initialAmount ?? detail?.initial_amount}</span>
        </div>
        <div
          className={`flex w-[145px] flex-none grow items-center justify-center border-r ${COMMON_CLASSES}`}
          style={{ borderColor: HNSColors.neutrals[700] }}
        >
          <EditableCurrencyCell
            detail={detail}
            fieldKey="settled_amount"
            value={detail?.settledAmount ?? detail?.settled_amount ?? ""}
            onSaveSuccess={onSaveSuccess}
            canEdit={canEdit}
          />
        </div>
        <div
          className={`flex w-[90px] flex-none grow items-center justify-center border-r ${COMMON_CLASSES}`}
          style={{ borderColor: HNSColors.neutrals[700] }}
        >
          {Math.round(detail?.discount || 0)}%
        </div>
        <div
          className={`flex w-[160px] flex-none grow items-center justify-center border-r ${COMMON_CLASSES}`}
          style={{ borderColor: HNSColors.neutrals[700] }}
        >
          <span
            className="flex min-h-[28px] w-full items-center justify-center rounded-full px-3 py-1 text-xs font-medium"
            style={{
              backgroundColor:
                detail?.providerInNetwork ?? detail?.provider_in_network
                  ? HNSColors.success[700]
                  : HNSColors.failure[700],
            }}
          >
            {detail?.providerInNetwork ?? detail?.provider_in_network
              ? "In Network"
              : "Out of Network"}
          </span>
        </div>
        <div
          className={`flex w-[220px] flex-none grow items-center justify-center ${COMMON_CLASSES}`}
          style={{ borderColor: HNSColors.neutrals[700] }}
        >
          <ProviderSettlementStatusSelect
            detail={detail}
            options={statusOptions}
            disabled={!canEdit}
          />
        </div>
      </div>
    </ListItem>
  );
}
